import ElementUI from 'element-ui'
import { VatCentre_Declare_AuthUrl } from '@/api'
export const GetAuthUrl = id => {
  if(!id) return;
  ElementUI.MessageBox.confirm('授权已失效，请重新授权', '提示', {
    confirmButtonText: '重新授权',
    type: 'warning'
  }).then(() => {
    VatCentre_Declare_AuthUrl({
      id,
      NEED_DEVICE: true
    }).then(({auth_url}) => {
      ElementUI.Message.success('正在跳转至授权页面...');
      location.href = auth_url;
    })
  }).catch(() => {})
}


// WEBPACK FOOTER //
// ./src/views/vat_centre/declare/getAuthUrl.js